export function campaignLinkRequest(job,options,stepKey){
  const step=options?.steps?.find(s=>s.stepKey===stepKey)
  if(!job?.id||options?.jobId!==job.id||options.expectedJobVersion!==job.version||!step||options.blockedReason)throw Error('Reload the current saved job and canonical campaign step before linking.')
  return {jobId:job.id,expectedJobVersion:job.version,campaignId:options.campaignId,stepKey:step.stepKey,stepVersion:step.stepVersion}
}
export function campaignAttachmentRequest(job,row){
  const engine=job?.artworkEngine,asset=job?.assets?.find(a=>a.id===engine?.outputAssetId)
  if(!engine||!asset||row?.jobId!==job.id||row.stale||row.artwork?.revision!==engine.revision)throw Error('Select a saved original with the current exact revision before attaching it to this sequence step.')
  return {expectedJobVersion:job.version,engineRevision:engine.revision,outputAssetId:asset.id,sha256:asset.sha256,specFingerprint:engine.specFingerprint}
}
export function campaignReviewHref(row){
  const expected='/artwork-studio?job='+encodeURIComponent(row?.jobId||'')+'&tool=engine'
  return row?.jobId&&row.reviewUrl===expected?expected:null
}
